import { Injectable } from '@angular/core';
import { AccessRightType, ApplicationSettingsType, SideListOptionType } from '@fi-shared/types';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { ITabItem } from '@fi-app/utilities/tabs/tabs';
import { AppTextService } from '@fi-shared/app-text';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

@Injectable()
export class FiChecklistStatesService {
    constructor(
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private stateAccessCheckService: StateAccessCheckService,
        private appTextService: AppTextService,
        private fiDalogsService: FiDialogsService,
    ) {}

    getChecklistSettingsTabs(): ITabItem[] {
        const tabs: ITabItem[] = [];

        const shareRight = this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistLocal,
            AccessRightType.Share,
        );

        const adminRights = this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistLocal,
            AccessRightType.Admin,
        );

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Checklist.List)) {
            tabs.push({
                Title: this.appTextService.get('checklist.module_name'),
                Sref: FiStateNames.Checklist.List,
                SrefParams: { filterType: SideListOptionType.CurrentCheckLists },
                AddState: shareRight ? FiStateNames.Checklist.Add : null,
            });

            if (shareRight) {
                tabs.push({
                    Title: this.appTextService.get('templates'),
                    Sref: FiStateNames.Checklist.Template.List,
                    AddState: adminRights ? FiStateNames.Checklist.Template.Add : null,
                });
            }
        }

        if (this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Checklist.Report.List)) {
            tabs.push({
                Title: this.appTextService.get('reports'),
                Sref: FiStateNames.Checklist.Report.List,
            });
        }
        return tabs;
    }

    showChecklistModuleRemovalWarningDialog(): void {
        this.fiDalogsService.warningConfirm({
            headerText: this.appTextService.get('checklist.checklist1_removal_title'),
            messageText: this.appTextService.get('checklist.checklist1_removal_message_web'),
            yesButtonText: this.appTextService.get('ok'),
            isNoButtonHidden: true,
            isNoButtonPrimaryColor: false,
            config: {
                panelClass: 'fi-rounded-dialog-panel',
                maxWidth: '640px',
                autoFocus: false,
            },
        });
    }
}
